import * as cardStyles from '../../../styles/commons/OngoingConsltCard';
import { colors } from '../../../styles/colors';
import { fonts, fontSizes } from '../../../styles/fonts';

export const fitnessPlanCard = cardStyles.cardView;

export const cardHeader = cardStyles.header;

export const cardTitle = cardStyles.cardTitle;

export const noPlanBody = {
    borderRadius: 5,
    border: '1px solid rgb(216, 216, 216)',
    padding: '40px 30px',
}

export const ctaWrapper = {
    display: 'flex',
    justifyContent: 'flex-start',
}



export const cta = {
    color: colors.fuschiaPink,
    fontFamily: fonts.mediumFont,
    ':not(:last-child)': {
        marginRight: 40,
    },
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    img: {
        margin: '0 11px 3px 0'
    }
}

export const fitnessCard = {
    backgroundColor: 'rgb(246, 249, 252)',
    borderRadius: 5,
    padding: 22
}

export const fitnessCardHeader = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'end',
    marginBottom: 21
}

export const fitnessCardTitle = {
    fontFamily: fonts.mediumFont,
    fontSize: fontSizes.large,
    color: colors.black,
    marginLeft: 16,
    flex: 1,
}

export const fitnessPlanState = {
    color: colors.slateBlue,
    marginLeft: 17
}

export const cardAction: any = {
    cursor: 'pointer',
    marginLeft: 50
}

export const fitnessCardDaysRow = {
    marginBottom: 21,
    display: 'flex',
    alignItems: 'center',
    fontFamily: fonts.mediumFont,
    fontSize: fontSizes.medium,
    color: colors.blackGrey,
    span: {
        display: 'inline-block',

    }
}

export const seperator = {
    display: 'inline-block',
    margin: '0 20px 2px 20px',
    height: 20,
    width: 1,
    backgroundColor: colors.dullGrey
}

export const fitnessDayFocusRow = {
    ...fitnessCardDaysRow,
    marginBottom: 12
}